/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/promotion.scss";
import Paging from "../../component/Inc/Paging";
import Tab from "../../component/Inc/Tab";

const OnlineConsulting = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    { title: "재전화 요청", cnt: "46", value: 0 },
    { title: "시범강의 요청", cnt: "653", value: 1 },
  ];
  return (
    <main className="com_container p_online_consulting">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_3">온라인 무료 상담</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">1개월</button>
                  <button className="com_btn line gray s">3개월</button>
                </div>
                <div className="date_wrap">
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <span className="divider"> ~ </span>
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>

            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="12%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="7%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>신청일</th>
                  <th>비고</th>
                  <th>전화번호</th>
                  <th>통화시간</th>
                  <th>통화 상태</th>
                  <th>메모</th>
                  <th>담임선생님</th>
                  <th>시범강의</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>아웃</td>
                  <td>010-1234-1324</td>
                  <td>1시간 30분</td>
                  <td>통화 불가</td>
                  <td>성격은 좋으나..</td>
                  <td className="td_point">_</td>
                  <td className="td_point">-</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>아웃</td>
                  <td>010-1234-1324</td>
                  <td>1시간 30분</td>
                  <td>통화 불가</td>
                  <td>성격은 좋으나..</td>
                  <td>
                    <button className="btn_link blue">김담임103</button>
                  </td>
                  <td>
                    <button className="btn_link red">요청중</button>
                  </td>
                </tr>
                <tr className="selected">
                  <td>15</td>
                  <td className="td_date">2023, 05, 20 12 : 30</td>
                  <td>아웃</td>
                  <td>010-1234-1324</td>
                  <td>1시간 30분</td>
                  <td>통화 불가</td>
                  <td>성격은 좋으나..</td>
                  <td className="td_point">_</td>
                  <td>
                    <button className="btn_link blue">
                      승인
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{14 - idx}</td>
                      <td className="td_date">2023, 05, 20 12 : 30</td>
                      <td>아웃</td>
                      <td>010-1234-1324</td>
                      <td>1시간 30분</td>
                      <td>통화 불가</td>
                      <td>성격은 좋으나..</td>
                      <td className="td_point">_</td>
                      <td className="td_point">-</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">실시간 통화 내용</div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">등록일시</span>
                  <span className="cont">2023, 05, 23 15 : 30</span>
                </div>
                <div className="info">
                  <span className="tit">지역</span>
                  <span className="cont">서울/경기</span>
                </div>
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">김학생</span>
                </div>
                <div className="info">
                  <span className="tit">휴대폰 번호</span>
                  <span className="cont">010-1234-1234</span>
                </div>
                <div className="info">
                  <span className="tit">학년 / 계열</span>
                  <span className="cont">고1 / 인문</span>
                </div>
                <div className="info">
                  <span className="tit">학교명</span>
                  <span className="cont">서울 경기고등학교</span>
                </div>
                <div className="info">
                  <span className="tit">상담가능시간</span>
                  <span className="cont">오전10시 ~ 12시</span>
                </div>
                <div className="info">
                  <span className="tit">유입경로</span>
                  <span className="cont">인터넷(온라인)을 통해</span>
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap flex_row">
              <button className="com_btn orange s btn_call">
                010-1234-1344 님과 통화중………
              </button>
              <button className="com_btn black s btn_hang_up">전화 끊기</button>
            </div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <p className="date dot">1시간 30분</p>
              <div className="count">
                <button className="btn_edit" />
                <button
                  type="button"
                  className="btn_arrow_down_circle"
                ></button>
              </div>
            </div>
            <div className="com_info line">
              <p className="name">홍길동103</p>
              <p className="date dot">2023, 05, 20</p>
              <p className="date dot">010-1234-3122</p>
              <p className="date dot">1시간 30분</p>
            </div>
            <div className="check">
              <input
                type="radio"
                name="rdo"
                id="rdo01"
                className="com_chk circle"
              />
              <label htmlFor="rdo01">재전화 요청</label>
              <input
                type="radio"
                name="rdo"
                id="rdo02"
                className="com_chk circle"
              />
              <label htmlFor="rdo02">재전화 불가</label>
              <input
                type="radio"
                name="rdo"
                id="rdo03"
                className="com_chk circle "
              />
              <label htmlFor="rdo03">호의적</label>
              <input
                type="radio"
                name="rdo"
                id="rdo04"
                className="com_chk circle "
              />
              <label htmlFor="rdo04">관심없음</label>
            </div>
            <textarea className="textarea" placeholder="메모 입력"></textarea>

            <div className="com_btn_wrap center">
              <div className="com_btn black s btn_plus_orange">
                홍보책자 발송
              </div>
              <div className="com_btn black s btn_plus_orange">
                시범강의 신청
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default OnlineConsulting;
